import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { useApp } from "@/context/AppContext";
import {
  Grid3x3, ClipboardList, QrCode, Receipt, BookOpen, ToggleRight,
  Banknote, Warehouse, BarChart3, Users, Settings, ArrowRight,
} from "lucide-react";

const SEZIONI = [
  {
    id: "servizio",
    titolo: "Servizio",
    voci: [
      { to: "/sala", label: "Sala e tavoli", nota: "Apri un tavolo, prendi la comanda", icon: Grid3x3 },
      { to: "/cassa", label: "Cassa e quadratura", nota: "Incassi, fondi cassa, fine serata", icon: Banknote },
      { to: "/monitor", label: "Monitor reparti", nota: "Cucina, pizzeria e bar", icon: ClipboardList },
    ],
  },
  {
    id: "configurazione",
    titolo: "Configurazione",
    voci: [
      { to: "/menu", label: "Menu", nota: "Piatti, prezzi, categorie", icon: BookOpen },
      { to: "/menu-fisso", label: "Menu fisso", nota: "Menu del giorno con scelta dei piatti", icon: ClipboardList, tag: "Nuovo", mod: "menu_fisso" },
      { to: "/menu-fisso", label: "Carta digitale QR", nota: "QR da tavolo per leggere il menu", icon: QrCode, tag: "Nuovo", mod: "carta_qr" },
      { to: "/cassa-fiscale", label: "Cassa fiscale", nota: "Scontrino su Epson, RCH, Ditron", icon: Receipt, tag: "Nuovo", mod: "cassa_fiscale" },
      { to: "/funzioni", label: "Funzioni attive", nota: "Accendi o spegni i moduli", icon: ToggleRight },
      { to: "/impostazioni", label: "Impostazioni locale", nota: "Logo, motto, dati fiscali", icon: Settings },
    ],
  },
  {
    id: "gestione",
    titolo: "Gestione",
    voci: [
      { to: "/statistiche", label: "Statistiche", nota: "Andamento incassi e piatti", icon: BarChart3, mod: "statistiche" },
      { to: "/magazzino", label: "Magazzino", nota: "Giacenze, ricette, sprechi", icon: Warehouse, mod: "magazzino" },
      { to: "/dipendenti", label: "Personale", nota: "PIN, ruoli, fondi cassa", icon: Users },
      { to: "/manuale", label: "Manuale d'uso", nota: "Guida stampabile per la squadra", icon: BookOpen, noShowcase: true },
    ],
  },
];

export const AccessiRapidi = () => {
  const { modules, showcase } = useApp();
  const attivo = (v) => (!v.mod || !modules || modules.includes(v.mod)) && !(v.noShowcase && showcase);
  return (
  <div className="space-y-4" data-testid="accessi-rapidi">
    <h3 className="text-lg font-semibold">Accesso rapido</h3>
    {SEZIONI.map((s) => (
      <Card key={s.id} className="p-5" data-testid={`accessi-${s.id}`}>
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{s.titolo}</p>
        <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3">
          {s.voci.filter(attivo).map((v) => (
            <Link
              key={`${s.id}-${v.label}`}
              to={v.to}
              data-testid={`quick-${v.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group flex items-start gap-3 rounded-xl border border-slate-200 p-3 transition-colors hover:border-slate-900 hover:bg-slate-50"
            >
              <v.icon className="mt-0.5 h-4 w-4 shrink-0 text-slate-500 transition-colors group-hover:text-slate-900" />
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="text-sm font-medium">{v.label}</span>
                  {v.tag && (
                    <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase text-amber-800">{v.tag}</span>
                  )}
                </span>
                <span className="mt-0.5 block truncate text-xs text-slate-500">{v.nota}</span>
              </span>
              <ArrowRight className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-300 transition-transform group-hover:translate-x-0.5 group-hover:text-slate-900" />
            </Link>
          ))}
        </div>
      </Card>
    ))}
  </div>
  );
};
